var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xEA\xB7\xB8\xEB\xA3\xB9 258"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xEA\xB7\xB8\xEB\xA3\xB9 255"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xEA\xB7\xB8\xEB\xA3\xB9 259"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xED\x8C\xA8\xEC\x8A\xA4 75",
    d: "M19.327 2H4.673C4.32202 1.99987 3.97446 2.06889 3.65016 2.20311C3.32587 2.33733 3.03119 2.53413 2.78296 2.78226C2.53474 3.03039 2.33783 3.32499 2.20349 3.64924C2.06915 3.97349 2 4.32102 2 4.672V19.327C2 20.0359 2.28162 20.7158 2.7829 21.2171C3.28419 21.7184 3.96408 22 4.673 22H19.327C20.0359 22 20.7158 21.7184 21.2171 21.2171C21.7184 20.7158 22 20.0359 22 19.327V4.672C22 4.32102 21.9309 3.97349 21.7965 3.64924C21.6622 3.32499 21.4653 3.03039 21.217 2.78226C20.9688 2.53413 20.6741 2.33733 20.3498 2.20311C20.0255 2.06889 19.678 1.99987 19.327 2ZM20.7 19.327C20.6995 19.691 20.5546 20.0399 20.2973 20.2973C20.0399 20.5546 19.691 20.6995 19.327 20.7H4.673C4.30902 20.6995 3.9601 20.5546 3.70273 20.2973C3.44535 20.0399 3.30053 19.691 3.3 19.327V4.672C3.30053 4.30811 3.44539 3.9593 3.70279 3.70208C3.96019 3.44487 4.30911 3.30026 4.673 3.3H19.327C19.6909 3.30026 20.0398 3.44487 20.2972 3.70208C20.5546 3.9593 20.6995 4.30811 20.7 4.672V19.327Z",
    fill: "#CED4DA"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckOff);
export default __webpack_public_path__ + "static/media/check_off.44495ed21a3fcc90394ee6495e976098.svg";
export { ForwardRef as ReactComponent };